import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const multiTariffShow = isFeature('multi-tariff-show');

export const multiTariffInitTab = getFeature('multi-tariff-init-tab') || 'basic';

type TariffList = {
    year: string[];
    month: string[];
};

export const multiTariffBasicTariffList: TariffList = getFeature('multi-tariff-basic-tariff-list') || {
    year: [
        'W2TB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W1TB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W512GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W256GB_1y_blackfriday_2023_discount_single_quota_cloud',
    ],
    month: [
        'W2T1m_single_quota_2022_cloud',
        'W1T1m_single_quota_2022_cloud',
        'W512G1m_single_quota_2022_cloud',
        'W256G1m_single_quota_2022_cloud',
    ],
};

export const multiTariffAdvancedTariffList: TariffList = getFeature('multi-tariff-advanced-tariff-list') || {
    year: [
        'W256GB_1y_landing_segmentation_discount',
        'W512GB_1y_landing_segmentation_discount',
        'W1TB_1y_landing_segmentation_discount',
        'W2TB_1y_landing_segmentation_discount',
    ],
    month: [
        'W256GB_1m_landing_segmentation_discount',
        'W512GB_1m_landing_segmentation_discount',
        'W1TB_1m_landing_segmentation_discount',
        'W2TB_1m_landing_segmentation_discount',
        'W4TB_1m_landing_segmentation_discount',
    ],
};

export const multiTariffFamilyTariff = getFeature('multi-tariff-family-tariff') || 'W1TB_family_features_a';

export const multiTariffCloudBenefits = [
    {
        id: 'docs',
        name: 'Редактирование документов',
        free: true,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'autosave',
        name: 'Автосохранение файлов с телефона в Облако',
        free: true,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'size',
        name: 'Дополнительное место для файлов',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'infinity',
        name: 'Безлимитная автозагрузка фото и видео с телефона',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'support',
        name: 'Приоритетная поддержка',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'ad',
        name: 'Без рекламы',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'upload',
        name: 'Загрузка файлов до 100 ГБ в Облако',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'family',
        name: 'Можно делиться памятью ещё с 3 участниками',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'autodelete',
        name: 'Таймер для автоудаления отправленных папок',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'themed-publick',
        name: 'Выбор оформления для совместных папок',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'password',
        name: 'Пароль для совместных папок в веб-версии',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'family-folders',
        name: 'Семейные папки с общим доступом',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
    },
    {
        id: 'family-albums',
        name: 'Семейные альбомы с общим доступом',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
    },
    {
        id: 'benefits',
        name: 'Возможности тарифа у всех в подписке',
        free: false,
        paid: false,
        advanced: false,
        family: true,
        isNew: true,
    },
];

export const multiTariffMailBenefits = [
    {
        id: 'virus',
        name: 'Проверка вложений антивирусом',
        free: true,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'mail-size',
        name: 'Дополнительное место для писем',
        free: false,
        paid: true,
        advanced: true,
        family: true,
    },
    {
        id: 'ad',
        name: 'Без рекламы',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'send',
        name: 'Отправка вложений до 100 ГБ в письмах',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'cancel',
        name: 'Отмена отправки писем в течение 30 секунд',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'notification',
        name: 'Уведомления о прочтении ваших писем',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
    {
        id: 'widgets',
        name: 'Полезные виджеты Календаря и Задач всегда на виду',
        free: false,
        paid: false,
        advanced: true,
        family: true,
    },
];
